export const DATA_EXPORT_REQUEST = 'DATA_EXPORT_REQUEST';
export const DATA_EXPORT_SUCCESS = 'DATA_EXPORT_SUCCESS';
export const DATA_EXPORT_FAIL = 'DATA_EXPORT_FAIL';

export const RESET_DATA_EXPORT_STATE = 'RESET_DATA_EXPORT_STATE';

export const resetDataExportState = () => {
  return {
    type: RESET_DATA_EXPORT_STATE
  };
};
